module.exports = __webpack_public_path__ + "static/media/videoCall.41548e95.svg";